module.exports = __webpack_public_path__ + "05_glasses_red.2926ba53.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/05_glasses_red.png
// module id = FFZ3
// module chunks = 0